import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';

import { investments } from '@portal/config/app.json';
import { getRouteStackPath } from '@portal/config/routes';
import { translate } from '@portal/services/i18n';
import { sendEvent } from '@portal/services/firebase';
import { PageClass } from '@portal/enum/analytics';

import PanelContent from '@portal/components/PanelContent/PanelContent';
import HomeNavigationReport from '@portal/pages/Home/HomeNavigationReport/HomeNavigationReport';
import TransactionDetails from '@portal/pages/Home/TransactionDetails/TransactionDetails';
import InvestmentsPage from '@portal/pages/Investments/InvestmentsPage/InvestmentsPage';
import Receive from '@portal/pages/Home/Receive/Receive';
import Pay from '@portal/pages/Home/Pay/Pay';
import useReduxState from '@portal/hooks/useReduxState';
import { getPaymentAccountByType } from '@portal/utils/paymentAccount';
import { PaymentAccountType } from '@portal/models/enumerators/paymentAccount';

const HomeNavigationStack = () => {
  useEffect(() => {
    sendEvent('page_view', {
      firebase_page: location.pathname,
      firebase_page_class: PageClass.HOME,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const {
    user: { me: loggedUser },
  } = useReduxState();

  const paymentAccount = getPaymentAccountByType(
    loggedUser,
    PaymentAccountType.ACCOUNT
  );

  const investmentAccount = getPaymentAccountByType(
    loggedUser,
    PaymentAccountType.INVESTMENTS
  );

  return (
    <Switch>
      {paymentAccount || investmentAccount ? (
        <Route exact path={getRouteStackPath('HOME', 'HOME_PAGE')}>
          {!investments.homePage ? (
            <PanelContent pageTitle="Início">
              <HomeNavigationReport />
            </PanelContent>
          ) : (
            <PanelContent
              pageTitle={translate('PAGES.HOME.INVESTMENTS.PAGE_TITLE')}
            >
              <InvestmentsPage />
            </PanelContent>
          )}
        </Route>
      ) : null}

      <Route
        exact
        path={`${getRouteStackPath('HOME', 'MY_ACCOUNT_DETAILS')}:id`}
      >
        <PanelContent
          pageTitle={translate('COMPONENTS.USERS_TRANSACTIONS.DETAILS.TITLE')}
          pageDescription={translate(
            'COMPONENTS.USERS_TRANSACTIONS.DETAILS.DESCRIPTION'
          )}
        >
          <TransactionDetails />
        </PanelContent>
      </Route>

      {paymentAccount || investmentAccount ? (
        <Route exact path={getRouteStackPath('HOME', 'PAY')}>
          <PanelContent pageTitle={translate('PAGES.HOME.PAY.TITLE')}>
            <Pay />
          </PanelContent>
        </Route>
      ) : null}

      {paymentAccount || investmentAccount ? (
        <Route exact path={getRouteStackPath('HOME', 'RECEBER')}>
          <PanelContent pageTitle={translate('PAGES.HOME.RECEIVE.TITLE')}>
            <Receive />
          </PanelContent>
        </Route>
      ) : null}
    </Switch>
  );
};

export default HomeNavigationStack;
